import React from 'react';
import { FadeIn } from '../FadeIn';
import { ArrowRight } from 'lucide-react';
export function FinalCTAAHA() {
  return <section className="relative py-24 md:py-32 bg-forest overflow-hidden" data-id="element-109">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-110">
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-white/5 rounded-full blur-3xl" data-id="element-111"></div>
        <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-gold/10 rounded-full blur-3xl" data-id="element-112"></div>

        {/* Large background text */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[25vw] font-serif font-bold text-ivory/[0.03] whitespace-nowrap select-none tracking-widest" data-id="element-113">
          A.H.A.
        </div>

        {/* Decorative lines/dots */}
        <div className="absolute top-10 left-10 w-20 h-20 border-t border-l border-gold/20" data-id="element-114"></div>
        <div className="absolute bottom-10 right-10 w-20 h-20 border-b border-r border-gold/20" data-id="element-115"></div>
        <div className="absolute top-1/4 right-1/4 w-2 h-2 bg-gold/40 rounded-full" data-id="element-116"></div>
        <div className="absolute bottom-1/4 left-1/4 w-1.5 h-1.5 bg-ivory/30 rounded-full" data-id="element-117"></div>
      </div>

      <div className="max-w-[1000px] mx-auto px-6 md:px-8 relative z-10 text-center" data-id="element-118">
        <FadeIn data-id="element-119">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-ivory mb-8 leading-tight max-w-[800px] mx-auto" data-id="element-120">
            Ești gata să începi?
          </h2>

          <p className="text-lg md:text-[21px] text-ivory/80 font-sans max-w-[700px] mx-auto mb-12 leading-relaxed" data-id="element-121">
            Dacă ai ajuns până aici și ceva a rezonat, probabil nu este
            întâmplător. Primul pas nu trebuie să fie mare. Trebuie doar să fie
            al tău.
          </p>

          <a href="#checkout" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-ivory text-forest font-display text-lg font-medium hover:bg-white transition-colors no-underline gap-3 group shadow-xl shadow-black/20" data-id="element-122">
            Începe cursul acum
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-123" />
          </a>

          <p className="mt-10 font-serif italic text-ivory/60 text-xl" data-id="element-124">
            Pentru că a simți nu înseamnă a te pierde.
          </p>
        </FadeIn>
      </div>
    </section>;
}